import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleRoadWorthyCheckRecordCategoryEnum } from '../enums/vehicle-road-worthy-check-record-category.enum';
import { VehicleRoadWorthyCheckStatusEnum } from '../enums/vehicle-road-worthy-check-status.enum';

import { VehicleRoadWorthyCheckLinksDto } from './vehicle-road-worthy-check-links.dto';

/**
 * Vehicle road worthy check DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE_ROAD_WORTHY_CHECK)
export class VehicleRoadWorthyCheckSearchDto extends BaseSearchDto {
  code!: string;
  externalReference?: string | null;
  startsAt!: Date;
  endsAt!: Date;
  status!: VehicleRoadWorthyCheckStatusEnum;
  recordCategory!: VehicleRoadWorthyCheckRecordCategoryEnum;
  vehicleVin!: string;
  vehicleLicensePlate?: string | null;
  vehicleMakeFull?: string | null;
  totalGross?: number | null;
  links?: VehicleRoadWorthyCheckLinksDto | null;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
